export const API_BASE = '/api/v1';
/** Identity helper that keeps literal types for inference. */
export const defineRoute = (r) => r;
/** `/api/v1/clients/{id}` → `/api/v1/clients/:id` (Fastify / React Router style). */
export const toColonPath = (path) => path.replace(/\{([^}]+)\}/g, ':$1');
/** Fill path params: `buildPath('/api/v1/clients/{id}', { id })`. */
export const buildPath = (path, params = {}) => path.replace(/\{([^}]+)\}/g, (_, k) => {
    const v = params[k];
    if (v === undefined)
        throw new Error(`Missing path parameter "${k}" for ${path}`);
    return encodeURIComponent(v);
});
//# sourceMappingURL=route.js.map